import styled from 'styled-components'

export default styled.div`
  background-color: ${({ theme }) => theme.color.background};
  display: flex;
  flex-direction: column;
  padding: 24px;
  opacity: 0.95;
  z-index: 3;
  min-height: 15rem;
`
